import React, {useEffect, useCallback, useRef} from 'react';

import PropTypes from 'prop-types';

function ClickOutside(props) {
    const wrapperRef = useRef();

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);


    const handleClickOutside = useCallback((event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            props.onClickOutside();
        }
    }, []);

    return <div ref={wrapperRef}>
        {props.children}
    </div>
}

ClickOutside.propTypes = {
    onClickOutside: PropTypes.func.isRequired,
};

export default ClickOutside;